import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import './config'
import './index.css'
import App from './App'
import { unregister } from './registerServiceWorker'

import store from './store'

unregister()

ReactDOM.render(
                <Provider store={store}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </Provider>
            , document.getElementById('root'))
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js